import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY, BUTTON_ACTION_HEIGHT } from 'common/constants';
import { SIZE, LAYERS } from 'common/sizes';
import { Label } from 'common/baseComponents';
import { LIST } from 'common/base';
import { MainContainer, SuggestLabel } from 'components/SearchableDropdown/styles';
import { ListItemContent } from 'components/ListEditor/styles';
import { InputContainer } from 'components/InputIcon/styles';
import { SearchInput } from 'components/SearchBox/styles';
/*
export const GeneralContainer = styled.div`
    display: flex;
    flex-flow: column;
    flex: 1;
    ${MainContainer} {
        height: unset;
    }
    ${ListItemContent} {
        padding: 0;
    }
    ${InputContainer} {
        box-shadow: none;
    }
`*/


export const BoxContainer1 = styled.div`    
    padding: 50px 65px 50px 34px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: -2px 4px 15px 0 rgba(0, 0, 0, 0.15);
    margin: 0px 0px 60px 0px;
`

export const BoxContainer2 = styled.div`    
    padding: 45px 65px 40px 103px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: -2px 4px 15px 0 rgba(0, 0, 0, 0.15);
    margin: 0px 0px 40px 0px;
`

export const TexBody = styled.div`    
    display: flex;
    padding: 0px 0px 0px 0px;
`

export const GeneralContainer = styled.div`
    display: flex;
    flex-flow: column;
    flex: 1;
    width: 100%;
    padding: 29px 94px;
`


export const DepartmentsMessage = styled.div`
  font-family: Rubik;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
`

export const Subtitle = styled.div`
    
    margin: 0 0px 0px 0;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
`

export const LinkSection = styled.div`
    width: 100%;    
`

export const Row = styled.div`
    display: flex;
    align-items: center;
    flex-flow: row;
    padding-bottom: 20px;
    max-width: ${SIZE.EIGHTY_TWO}px;
`
export const RowButton = styled.div`
    display: flex;
    flex-flow: row;
    padding-top: 25px;
    max-width: ${SIZE.EIGHTY_TWO}px;
    float: right;
`

export const TitleButton = styled.div`
    display: flex;
    flex-flow: row;
    padding-top: ${SIZE.THREE}px;
    max-width: ${SIZE.EIGHTY_FOUR}px;
    justify-content: flex-end;
`


export const ColumnHeader = styled.div`
    width: ${SIZE.THIRTY_FIVE}px;
    height: 19px;
    flex-grow: 0;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    padding-bottom: 7px;
`

export const DepartmentName = styled.div`
    width: ${SIZE.THIRTY_FIVE}px;
    height: 19px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
`

export const LocationSelect = styled.div`
    position: relative;
    display: flex;
    flex: 1;
    padding: 0px;
`

export const LocationPicker = styled.input`
    border-radius: 5px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(130, 130, 130, 0.5);
    background-color: #ffffff;
    position: relative;
    flex:unset;
    font-family: ${DEFAULT_FONT_FAMILY};
    padding: ${SIZE.ONE}px ${SIZE.TWO}px ${SIZE.ONE}px ${SIZE.TWO}px;
    height: ${BUTTON_ACTION_HEIGHT};
    width: ${SIZE.THIRTY_TWO}px;

    ::placeholder {
        margin: 0 4.7px 0 0;
        font-family: ${DEFAULT_FONT_FAMILY};
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: rgba(112, 112, 112, 0.5);
    }
`

export const SaveButton = styled.button`
    border-width: 0;
    border-radius: 5px;
    width: ${SIZE.NINETEEN}px;
    height: ${SIZE.FOUR + SIZE.HALF}px;
    flex-grow: 0;
    
    background-color: #4da0ff;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);    
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;

    &:disabled {
        background-color: #bdbdbd;
        border: none;
    }

    &:hover {
        cursor: pointer;
    }
`

export const RightAlign = styled.div`
    margin-left: ${SIZE.FIFTYTWO}px;
`

export const Tools = styled.div`
    margin-left: 0;
    display: flex;
    flex-flow: row;
`

//DRAWER

export const DrawerContainer = styled.div`
    position: absolute;
    top: ${SIZE.SEVEN}px;

    min-width: ${SIZE.THIRTY_SIX}px;
    height: 434px;
    padding: 14px 0px 16px 0px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(130, 130, 130, 0.5);

    z-index: ${LAYERS.LAYER_4};
    display: flex;
    flex-flow: column;
    
    max-height: ${SIZE.NINETEEN}px;
    background: white;

    border-radius: ${SIZE.HALF}px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: ${SIZE.ONE}px;

`

export const DrawerOptionsContainer = styled.div`
    background: white;
    display:flex;
    flex:1;
    overflow: auto;
`

export const DrawerList = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-flow: column;
    flex:1;
    overflow: auto;

    ${SearchInput} {
        font-family: ${DEFAULT_FONT_FAMILY};
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
    }
`
export interface DrawerListItemProps {
    highlighted: boolean
}

export const DrawerListItem = styled.li`
    height: ${SIZE.FOUR}px;
    display:flex;
    align-items: center;
    &:hover {
        cursor: pointer;
    };
    background: ${(props: DrawerListItemProps) => props.highlighted ? '#DADADA' : 'none'};
`
export const DrawerItemLabel = styled(Label)`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    overflow:hidden;
    white-space:nowrap;
    color: #373f53;
`

//HOVERABLE

export const IconWrapper = styled.div`
    display: flex;
    &:hover {
        cursor: pointer;
    }
    padding-left:${SIZE.THREE}px;
    margin: auto;
`

export const Explanation = styled.div`
    
    flex-grow: 0;
    margin: ${SIZE.HALF}px;
    font-family: Rubik;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #122442;
`

export const IconContainer = styled.div
`
    display: flex;
    margin-right: ${SIZE.THREE}px;
`